module.exports = __webpack_public_path__ + "img/hero-bg.1d703fc5.png";